import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper'
import { Navigation, Pagination, Thumbs, A11y } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/thumbs'

export default class extends Controller {
  static targets = ["main", "thumbs"]

  connect() {
    if (this.hasMainTarget) {
      this.initSwiper()
    }
  }

  disconnect() {
    if (this.mainSwiper) {
      this.mainSwiper.destroy()
      this.mainSwiper = null
    }
    if (this.thumbsSwiper) {
      this.thumbsSwiper.destroy()
      this.thumbsSwiper = null
    }
  }

  initSwiper() {
    // Initialize Thumbs Swiper first
    if (this.hasThumbsTarget) {
      this.thumbsSwiper = new Swiper(this.thumbsTarget, {
        modules: [Navigation, Thumbs],
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          320: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 4,
          }
        }
      })
    }

    // Initialize Main Swiper
    if (this.hasMainTarget) {
      const modules = [Navigation, Pagination]
      const config = {
        modules: modules,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        grabCursor: true
      }

      if (this.thumbsSwiper) {
        modules.push(Thumbs)
        config.thumbs = {
          swiper: this.thumbsSwiper
        }
      }

      this.mainSwiper = new Swiper(this.mainTarget, config)
    }
  }
}
